<template>
    <div class="groupNews">
         <div class="headTitle">
            <div class="shadowTxt">NEWS</div>
            <div class="title">集团要闻</div>
        </div>
        <div class="news">
            <div class="part" v-for="item in news" :key="item.id" @click="newsDetails(item.id)">
                <div class="time">{{ item.year }}.{{ item.month }}.{{item.day}}</div>
                <div class="title">{{ item.title }}</div>
                <div class="text">{{ item.descr }}</div>
            </div>
            <!-- <div class="part">
                <div class="time">2021.08.20</div>
                <div class="title">爱情地产京津冀战区工程大比武圆满举行</div>
                <div class="text">中新网客户端北京6月11日电(记者 张尼)明天起，2021年端午小长假大幕将正式开启。作为今年上半年最后一个小长假，这个假期预计将有1亿人次出游。哪些目的地最热门？</div>
            </div> -->
        </div>
    </div>
</template>
<script>
import {apiGetNews} from '../../api/index'

export default {
  metaInfo: {
      title: '集团要闻-爱情地产',
      meta: [{
      name: 'keyWords',
      content: '爱情地产'
      },
      {
      name: 'description',
      content: ''
      }]
  },
  data(){
      return{
          news:[]
      }
  },
  methods: {
    init() {
      apiGetNews().then((data) => {
        if (data.data.status == 1) {
          this.news = data.data.news;
          this.fourNews = this.news.slice(0, 4);
          this.yearsLists = data.data.year;
        }
      });
    },
    newsDetails(id) {
      this.$router.push({
        name: "newsDetails",
        params: {
          id: id,
        },
      });
    },
  },
   mounted() {
    this.init();
  },
};
</script>

<style scoped lang='less'>
*{
    margin: 0;
    padding: 0;
}
.headTitle{
    padding: 20px 15px 7px 15px;
    background: #fff;
    .shadowTxt{
        font-size: 40px;
        line-height: 47px;
        color: #F8F8F8;
        font-family: 'DIN Alternate Bold';
        font-weight: bold;
    }
    .title{
        color: #222;
        font-size: 18px;
        line-height: 25px;
        font-family: '苹方-简 中黑体';
        font-weight: 600;
        margin-top: -28px;
    }
}
.news{
    .part{
        padding: 20px 15px;
        border-bottom: 1px solid #EFEFEF;
        .time{
            color: #E95506;
            font-size: 20px;
            line-height: 24px;
            font-family: 'DIN Alternate Bold';
            margin-bottom: 5px;
            font-weight: 600;
        }
        .title{
            color: #000;
            font-family: '苹方-简 中黑体';
            font-size: 14px;
            line-height: 20px;
            font-weight: 600;
            margin-bottom: 5px;
        }
        .text{
            color: #666;
            font-family: '苹方-简 常规体';
            font-size: 12px;
            line-height: 20px;
        }
    }
}
</style>